import { Layout } from "react-admin";
import { HelmetProvider } from "react-helmet-async";
import MyAppBar from "../appBars/CustomAppBar";
import DynamicTitle from "../DynamicTitle";
import AuditLogGlobalModal from "../AuditLogGlobalModal";
import { useRef } from "react";

const MyLayout = ({ children, ...props }) => {
  const EmptyMenu = () => null;
  const auditLogModalRef = useRef(null);

  return (
    <HelmetProvider>
      <DynamicTitle />
      <Layout
        {...props}
        menu={EmptyMenu}
        appBar={MyAppBar}
        sx={{
          '& .RaLayout-content': { marginLeft: '0 !important', transition: 'none' },
          '& .RaSidebar-docked, & .RaSidebar-root': { display: 'none' },
        }}
      >
        {children} {/* tidak perlu cloneElement */}
      </Layout>

      {/* Modal global */}
      <AuditLogGlobalModal ref={auditLogModalRef} />
    </HelmetProvider>
  );
};

export default MyLayout;
